@reference "@glow/tailwind-config/reference.css";

.container {
  @apply flex;
  @apply items-center;
  @apply gap-4;
  @apply p-2;
}
